<style lang="scss">
  @import '../resources/scss/project_data_section.scss';
</style>

<script lang="ts">
  import type ProjectPartners from '../api/rest/directus-cms/projects/model/ProjectPartners'

  export let partnersArray: ProjectPartners[]
</script>

<div class="container-fluid bg-white">
  <div class="container-xxl flex-grow-1">
    <div class="row data-content">
      <div class="col-12">
        <div class="d-flex justify-content-start flex-wrap partner-images-container">
          {#each partnersArray as partner}
            {#if partner.partners_id?.image?.fullUrl}
              <div class="d-block w-auto text-center">
                <img
                  class="partner-image"
                  src={partner.partners_id?.image?.fullUrl}
                  alt=""
                />
                {#if partner.partners_id && partner.partners_id.translations}
                  {#if partner.partners_id.translations.length > 0}
                    {#if partner.partners_id.translations[0]}
                      <div class="h5 pt-2 text-neutral-b text-center">
                        {partner.partners_id.translations[0].name}
                      </div>
                    {/if}
                  {/if}
                {/if}
              </div>
            {/if}
          {/each}
        </div>
      </div>
    </div>
  </div>
</div>
